module.exports = __webpack_public_path__ + "static/signature-5f145e744ac569891581f7a1cbc63221.gif";